import * as React from 'react';
export const IcLightbulb = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zM7.4 7.9a1 1 0 000-1.41l-.7-.71a1 1 0 00-.7-.29 1 1 0 00-.921 1.385A1 1 0 005.3 7.2l.7.7a1 1 0 001.4 0zm-2.9 3.6h-1a1 1 0 000 2h1a1 1 0 000-2zm16.71.29a1 1 0 00-.71-.29h-1a1 1 0 000 2h1a1 1 0 00.71-1.71zM19 6.49a1 1 0 00-1.71-.71l-.7.71a1 1 0 000 1.41 1 1 0 001.4 0l.72-.7a1 1 0 00.29-.71zM14 19h-4a1 1 0 000 2h4a1 1 0 000-2zm1.56-10.85a6 6 0 00-7.09 0 5.87 5.87 0 00.43 9.66 1 1 0 00.53.15H11v-3.21l-1-1a1 1 0 01-.22-.33.94.94 0 010-.76 1 1 0 011.63-.33L12 13l.63-.63a1 1 0 011.63.33.94.94 0 010 .76 1 1 0 01-.22.33l-1 1V18h1.57a1 1 0 00.53-.15 5.86 5.86 0 00.38-9.7h.04z'
      fill='currentColor'
    />
  </svg>
);
